import { atom } from "jotai";
import "./App.css";
import Footer from "./components/common/Footer";
import Navbar from "./components/common/Navigation";
import Home from "./Pages/Home";
import AllRoutes from "./routes";
export const FilterValue = atom({
  brand:"",
  model: "",
  gadType:"",
  color:"",
  minPrice: 0,
  maxPrice: 0,
});
export const User = atom('')


function App() {
  return (
    <div className="App">
      <Navbar />
      <AllRoutes />
      <Footer />
    </div>
  );
}

export default App;
